export default __webpack_public_path__ + "static/media/cellnet_logo.3bd99f45.svg";